<template>
  <dd-modal
      :show-cancel="true"
      @cancel="$emit('close')"
      v-bind="$attrs"
      :visible="visible"
  >
    <dd-header-card
        :header="'Notitie: ' + (note.title !== undefined ? note.title : '...')"
        data-dusk="view-note-modal"
    >
      <table class="custom-table">
        <tr>
          <th style="width: 200px !important; border-radius: 4px 0 0 0;">
            Aangemaakt
          </th>
          <td v-if="loading"><Skeleton class="skeleton" style="width: 100%; height: 20px;"></Skeleton></td>
          <td v-else>{{ dateFormatter(note.created_at) }}</td>
        </tr>
        <tr>
          <th>Voor</th>
          <td v-if="loading"><Skeleton class="skeleton" style="width: 100%; height: 20px;"></Skeleton></td>
          <td v-else>{{ customer.full_name || '-' }}</td>
        </tr>
        <tr>
          <th>Door</th>
          <td v-if="loading"><Skeleton class="skeleton" style="width: 100%; height: 20px;"></Skeleton></td>
          <td v-else>{{ user.fullname || '-' }}</td>
        </tr>
        <tr>
          <th>In</th>
          <td v-if="loading"><Skeleton class="skeleton" style="width: 100%; height: 20px;"></Skeleton></td>
          <td v-else>
            <a :href="parent.uri">{{ parent.description }} {{ parent.name }}</a>
          </td>
        </tr>
        <tr>
          <th>Zichtbaar voor klant?</th>
          <td v-if="loading"><Skeleton class="skeleton" style="width: 100%; height: 20px;"></Skeleton></td>
          <td v-else>
            <eye-icon v-if="note.visible_for_customer" title="Zichtbaar"></eye-icon>
            <eye-off-icon v-else title="Niet zichtbaar"></eye-off-icon>
          </td>
        </tr>
        <tr>
          <th>Onderwerp</th>
          <td v-if="loading"><Skeleton class="skeleton" style="width: 100%; height: 20px;"></Skeleton></td>
          <td v-else>{{ note.title }}</td>
        </tr>
        <tr>
          <th style="vertical-align: top; border-radius: 0 0 0 4px; border-bottom: none !important;">
            Inhoud
          </th>
          <td v-if="loading"><Skeleton class="skeleton" style="width: 100%; height: 60px;"></Skeleton></td>
          <td v-else>{{ note.content }}</td>
        </tr>
      </table>
    </dd-header-card>
  </dd-modal>
</template>

<script>
import moment from 'moment';
import noteApi from '../../../api/note';
import { mapState, mapActions, mapGetters, mapMutations  } from 'vuex';
import DateFormatEnum from "~/enums/DateFormatEnum";
import { Skeleton } from 'vue-loading-skeleton'

export default {
  name: "ViewNoteModal",
  props: {
    visible: Boolean,
    noteId: {
      required: false,
      type: [Number, String],
    }
  },
  components: {
    Skeleton,
  },
  data() {
    return {
      loading: false,
      note: {},
      includes: [
        'user',
        'customer',
        'attachable.parent_instance'
      ],
    }
  },
  computed: {
    DateFormatEnum() {
      return DateFormatEnum
    },
    ...mapState(`$_customer_page`, {
      showViewNoteModal: 'showViewNoteModal',
    }),
    user() {
      if (this.note !== null && typeof this.note.user !== 'undefined' && this.note.user !== null) {
        return this.note ? this.note.user.data : {}
      }
      return {};
    },
    customer() {
      if (this.note !== null && typeof this.note.customer !== 'undefined' && this.note.customer !== null) {
        return this.note ? this.note.customer.data : {}
      }
      return {};
    },
    parent() {
      if (this.note !== null && typeof this.note.attachable !== 'undefined' && this.note.attachable !== null
          && typeof this.note.attachable.data !== 'undefined' && this.note.attachable.data !== null
          && typeof this.note.attachable.data.parent_instance !== 'undefined' && this.note.attachable.data.parent_instance !== null) {
        return this.note ? this.note.attachable.data.parent_instance.data : {}
      }
      return {};
    },
  },
  watch: {
    noteId(id) {
      if (this.visible) {
        this.loading = true;

        noteApi.find(id, this.includes)
            .then((response) => {
              this.note = {...this.note, ...response.data};
            })
            .finally(() => {
              this.loading = false;
            });
      }
    },
    showViewNoteModal(visible) {
      if(!visible) {
        this.onClose();
      }
    }
  },
  methods: {
    onClose() {
      this.setViewNoteId(null);
      this.setShowViewNoteModal(false);
      this.note = {};
      this.$emit('close');
    },
    ...mapMutations(`$_customer_page`, {
      setViewNoteId: "SET_VIEW_NOTE_ID",
      setShowViewNoteModal: 'SET_SHOW_VIEW_NOTE_MODAL',
    }),
    dateFormatter(date) {
      return moment(date, moment.ISO_8601).format(DateFormatEnum.DISPLAY_DATE);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";
</style>
